import React from "react";
import logo from "../assets/LOGO.png";

function Navbar(props) {
  return (
      
  <div className="container-fluid pt-4 pb-3 bg-dark header">
      <div className="row">
        <div className="col text-center">
          <img
              src={logo}
              alt="logo"
              style={{ width: 75, marginRight: 10, display: "inline" }}
            />
          <a href="https://edboardjssstu.in/" target="_blank" rel="noreferrer">
            <h2 className="fw-bold text-white">{props.info.title}</h2>
            <h5 className="text-white">{props.info.org}</h5>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
